import { axios } from '@/utils/request'

export function getRiskConversionReport(params) {
  return axios({
    url: '/riskReport/conversionList',
    method: 'get',
    params
  })
}
